import classNames from 'classnames';
import React from 'react';

import { useIsPhone } from '@sravni/react-utils';

import { PreloaderPolygon } from '../../../Preloader';

import styles from './article-preloader.module.scss';

export interface IArticlePreloaderProps {
  short?: boolean;
  color?: 'dark';
  withImage?: boolean;
}

export const ArticlePreloader: React.FC<IArticlePreloaderProps> = ({ short, color, withImage = true }) => {
  const isPhone = useIsPhone();

  const colorClass = color && styles[`container_${color}`];
  if (short) {
    return (
      <div className={classNames(styles.containerShort, colorClass, !withImage && styles.containerWithoutImage)}>
        {withImage && <PreloaderPolygon className={styles.image} />}

        <div className={styles.row} style={{ marginBottom: 28 }}>
          <PreloaderPolygon className={styles.element} style={{ width: '100px' }} />
        </div>
        <div className={styles.row} style={{ marginBottom: 12 }}>
          <PreloaderPolygon className={styles.element} style={{ width: '88%' }} />
        </div>
        <div className={styles.row} style={{ marginBottom: 12 }}>
          <PreloaderPolygon className={styles.element} />
        </div>
        <div className={styles.row} style={{ marginBottom: 24 }}>
          <PreloaderPolygon className={styles.element} style={{ width: '92%' }} />
        </div>
        <div className={styles.row} style={{ marginTop: 24 }}>
          <PreloaderPolygon className={styles.element} style={{ width: '100px' }} />
        </div>
      </div>
    );
  }

  return (
    <div className={classNames(styles.container, colorClass)}>
      <div className={styles.row} style={{ marginBottom: 28 }}>
        <PreloaderPolygon className={styles.element} style={{ width: isPhone ? '45%' : '22%' }} />
        <PreloaderPolygon className={styles.element} style={{ width: '19%' }} />
        {!isPhone && <PreloaderPolygon className={styles.element} style={{ width: '14%' }} />}
      </div>
      <div className={styles.row} style={{ marginBottom: 12 }}>
        <PreloaderPolygon className={styles.element} />
      </div>
      <div className={styles.row} style={{ marginBottom: 28 }}>
        <PreloaderPolygon className={styles.element} style={{ width: '88%' }} />
      </div>
      <div className={styles.row} style={{ marginBottom: 12 }}>
        <PreloaderPolygon className={styles.element} style={{ width: '88%' }} />
      </div>
      <div className={styles.row} style={{ marginBottom: 12 }}>
        <PreloaderPolygon className={styles.element} />
      </div>
      <div className={styles.row} style={{ marginBottom: 24 }}>
        <PreloaderPolygon className={styles.element} style={{ width: '92%' }} />
      </div>
      <PreloaderPolygon className={styles.image} />
      {!isPhone && (
        <div className={styles.row} style={{ marginTop: 24, justifyContent: 'space-between' }}>
          <div className={styles.row}>
            <PreloaderPolygon className={styles.element} style={{ width: '10%' }} />
            <PreloaderPolygon className={styles.element} style={{ width: '10%' }} />
          </div>
          <PreloaderPolygon className={styles.element} style={{ width: '20%' }} />
        </div>
      )}
    </div>
  );
};
